// extracted by mini-css-extract-plugin
export default {"black__bg":"styles_black__bg__nnCL3"};